export const PLAYER_STATE = /** @type {const} */ ({
  INITIALIZE: 'INITIALIZE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
});

/**
 * @typedef {PLAYER_STATE[keyof typeof PLAYER_STATE]} PlayerState
 */
